"use client";
import { usePathname, useRouter } from "next/navigation";

export default function ServicesTabs() {
  const router = useRouter();
  const pathname = usePathname();

  const tabs = [
    { id: "buy", label: "Buy Gold", path: "/buy-gold" },
    { id: "sell", label: "Sell Gold", path: "/sell-gold" },
    { id: "delivery", label: "Gold Delivered", path: "/gold-delivery" },
  ];

  const activeIndex = tabs.findIndex((tab) => tab.path === pathname);

  return (
    <div className="relative w-full max-w-7xl mx-auto mt-10 px-4">
      {/* Tabs */}
      <div className="flex justify-center border-b border-gray-200 relative">
        {tabs.map((tab) => {
          const isActive = pathname === tab.path;

          return (
            <button
              key={tab.id}
              onClick={() => router.push(tab.path)}
              className={`flex-1 text-center pb-3 text-lg font-semibold transition-colors ${
                isActive ? "text-primary" : "text-gray-500 hover:text-primary"
              }`}
            >
              {tab.label}
            </button>
          );
        })}

        {/* Active underline */}
        <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gray-200">
          <div
            className="absolute h-[2px] bg-blue-900 transition-all duration-300"
            style={{
              width: "33.3333%",
              left: `${activeIndex * 33.3333}%`,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
